import { combineSlices } from "@reduxjs/toolkit";
import { gs1Slices } from "./Gs1/store";

const partnerSlice = combineSlices({
  gs1: gs1Slices
});

export default partnerSlice;
